import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'equine-ui-nx-map',
    standalone: true,
    imports: [],
    templateUrl: './map.component.html',
    styleUrl: './map.component.scss',
})
export class USMapComponent {
    @Input() activeStates: string[] = [];

    @Output() stateUpdateEvent = new EventEmitter<any>();

    getClass(state: string): string {
        return this.activeStates.includes(state) ? "active" : "";
    }

    toggleStateSelection(state: string) {
        this.stateUpdateEvent.emit(state);
    }
}